{
  "app": {
    "name": "Teach",
    "tagline": "Apprendre et enseigner, pas à pas."
  },
  "nav": {
    "home": "Accueil",
    "courses": "Cours",
    "skipToContent": "Aller au contenu principal",
    "legal": "Informations légales"
  },
  "home": {
    "heading": "La plateforme est en place",
    "intro": "Le socle technique est opérationnel. Les fonctionnalités arrivent phase par phase.",
    "statusHeading": "État de l'API",
    "roadmapHeading": "Prochaine étape",
    "roadmapBody": "Phase 1 — identité, authentification et permissions."
  },
  "api": {
    "version": "Version",
    "environment": "Environnement",
    "locales": "Langues disponibles",
    "reachable": "API joignable",
    "loading": "Interrogation de l'API…",
    "retry": "Réessayer"
  },
  "errors": {
    "account_locked": "Trop de tentatives. Réessayez dans quelques minutes.",
    "account_unavailable": "Ce compte n'est pas accessible. Contactez le support.",
    "bad_request": "La requête est incorrecte.",
    "conflict": "Cette action entre en conflit avec l'état actuel.",
    "email_already_registered": "La création du compte a échoué. Essayez de vous connecter ou de réinitialiser votre mot de passe.",
    "entitlement_required": "Cette fonctionnalité nécessite un plan supérieur.",
    "fresh_auth_required": "Confirmez votre mot de passe pour continuer.",
    "internal_error": "Le serveur a rencontré un problème. Nos équipes sont prévenues.",
    "invalid_credentials": "Adresse email ou mot de passe incorrect.",
    "invalid_refresh_token": "Votre session a expiré. Reconnectez-vous.",
    "invalid_token": "Ce lien est invalide ou a expiré.",
    "network_error": "Impossible de joindre le serveur. Vérifiez votre connexion.",
    "no_deletion_pending": "Aucune suppression n'est en cours pour ce compte.",
    "not_found": "Cette ressource n'existe pas.",
    "permission_denied": "Vous n'avez pas les droits nécessaires.",
    "rate_limited": "Trop de requêtes. Patientez un instant.",
    "requestId": "Référence : {{id}}",
    "role_not_self_assignable": "Ce rôle ne peut pas être choisi à l'inscription.",
    "session_not_found": "Cette session n'existe pas.",
    "title": "Une erreur est survenue",
    "token_expired": "Votre session a expiré. Reconnectez-vous.",
    "token_reuse_detected": "Votre session a été fermée par sécurité. Reconnectez-vous.",
    "unauthenticated": "Vous devez vous connecter pour continuer.",
    "unexpected_error": "Une erreur inattendue est survenue. Réessayez dans un instant.",
    "validation_error": "Certains champs sont invalides.",
    "weak_password": "Ce mot de passe ne respecte pas la politique de sécurité."
  },
  "notFound": {
    "heading": "Page introuvable",
    "body": "Le lien est peut-être erroné ou la page a été déplacée.",
    "backHome": "Retour à l'accueil"
  },
  "pagination": {
    "shown_one": "{{count}} ligne affichée",
    "shown_other": "{{count}} lignes affichées",
    "allShown": "fin de la liste",
    "loadMore": "Charger la suite",
    "loading": "Chargement…"
  },
  "error": {
    "heading": "Cet écran n'a pas pu s'afficher",
    "body": "Une erreur inattendue s'est produite. Réessayer suffit le plus souvent ; si le problème persiste, communiquez le détail ci-dessous au support.",
    "retry": "Réessayer",
    "details": "Détail technique"
  },
  "richText": {
    "toolbar": "Mise en forme",
    "placeholder": "Rédigez ici…",
    "bold": "Gras",
    "italic": "Italique",
    "underline": "Souligné",
    "strike": "Barré",
    "code": "Code",
    "heading": "Titre de niveau {{level}}",
    "bulletList": "Liste à puces",
    "orderedList": "Liste numérotée",
    "blockquote": "Citation",
    "codeBlock": "Bloc de code",
    "horizontalRule": "Séparateur",
    "align": {
      "left": "Aligner à gauche",
      "center": "Centrer",
      "right": "Aligner à droite",
      "justify": "Justifier"
    },
    "link": "Insérer un lien",
    "unlink": "Retirer le lien",
    "linkPrompt": "Adresse du lien (http, https ou mailto)",
    "table": {
      "insert": "Insérer un tableau",
      "addRowBefore": "Insérer une ligne au-dessus",
      "addRowAfter": "Insérer une ligne en dessous",
      "deleteRow": "Supprimer la ligne",
      "addColumnBefore": "Insérer une colonne à gauche",
      "addColumnAfter": "Insérer une colonne à droite",
      "deleteColumn": "Supprimer la colonne",
      "toggleHeaderRow": "Ligne d'en-tête",
      "mergeOrSplit": "Fusionner ou scinder les cellules",
      "delete": "Supprimer le tableau"
    },
    "undo": "Annuler",
    "redo": "Rétablir"
  }
}
